import { useState } from 'react';
import {
    isBlockedBypassable,
    type ForceOverridePayload,
    type OrthopulseOrderBlocked
} from '../../../../../services/orthopulseOrder';
import { validateForceReason } from './forceOverride';

export interface UseForceOverrideStateResult {
    /** True only when the caller holds the permission AND the current
     *  `blocked` state is one the server actually lets `force` bypass. */
    canShow: boolean;
    open: boolean;
    reason: string;
    reasonError: string | undefined;
    isReady: boolean;
    setReason: (reason: string) => void;
    openPanel: () => void;
    reset: () => void;
    buildPayload: () => ForceOverridePayload | undefined;
}

export function useForceOverrideState(
    canForceOrder: boolean,
    blocked: OrthopulseOrderBlocked
): UseForceOverrideStateResult {
    const canShow = canForceOrder && isBlockedBypassable(blocked);

    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState('');
    const reasonError = validateForceReason(reason);
    const isReady = canShow && open && !reasonError;

    const reset = () => {
        setOpen(false);
        setReason('');
    };

    const buildPayload = (): ForceOverridePayload | undefined =>
        isReady ? { force: true, forceReason: reason.trim() } : undefined;

    return {
        canShow,
        open,
        reason,
        reasonError,
        isReady,
        setReason,
        openPanel: () => setOpen(true),
        reset,
        buildPayload
    };
}
